import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('migration');
const type = createActionType('migration');

export const OPEN_CREATE_DIALOG = type('OpenCreateDialog');
export const CLOSE_CREATE_DIALOG = type('CloseCreateDialog');
export const OPEN_MIGRATE_DIALOG = type('OpenMigrateDialog');
export const CLOSE_MIGRATE_DIALOG = type('CloseMigrateDialog');
export const UPLOAD_FILE = apiType('UploadFile');
export const CREATE_MIGRATION = apiType('CreateMigration');
export const LIST_MIGRATIONS = apiType('ListMigrations');
export const SELECT_MIGRATION = type('SelectMigration');
export const GET_MIGRATION_FILES = apiType('GetMigrationFiles');
export const SET_MIGRATION_SHEETS = type('SetMigrationSheets');
export const SET_METADATA = apiType('SetMetadata');
export const SELECT_SHEET = type('SelectSheet');
export const MIGRATE_SHEETS = type('MigrateSheets');
export const CREATE_PROJECT = apiType('CreateProject');
export const CREATE_GRAPH = apiType('CreateGraph');
export const TOGGLE_GROUP = type('ToggleGroup');
export const EXPAND_ALL_GROUPS = type('ExpandAllGroups');
export const COLLAPSE_ALL_GROUPS = type('CollapseAllGroups');
